import React, { useState } from 'react';
import { Hero } from './components/Hero';
import { StatsRow } from './components/StatsRow';
import { ProcessTimeline } from './components/ProcessTimeline';
import { PortfolioGrid } from './components/PortfolioGrid';
import { LifestyleSlider } from './components/LifestyleSlider';
import { LocalExpertise } from './components/LocalExpertise';
import { Partners } from './components/Partners';
import { FieldNotes } from './components/FieldNotes';
import { Configurator } from './components/Configurator';
import { FooterCTA } from './components/FooterCTA';
import { Footer } from './components/Footer';
import { Menu, X } from 'lucide-react';
import { motion, AnimatePresence } from 'framer-motion';
export function App() {
  const [isMenuOpen, setIsMenuOpen] = useState(false);
  return <div className="min-h-screen bg-[#F5F3F0] text-[#1A1A1A] font-sans selection:bg-[#A07656] selection:text-white" data-id="element-0">
      {/* Navigation Overlay */}
      <AnimatePresence data-id="element-1">
        {isMenuOpen && <motion.div initial={{
        opacity: 0
      }} animate={{
        opacity: 1
      }} exit={{
        opacity: 0
      }} className="fixed inset-0 z-50 bg-[#1A1A1A] flex flex-col justify-center items-center" data-id="element-2">
            <button onClick={() => setIsMenuOpen(false)} className="absolute top-8 right-8 text-[#F5F3F0] hover:text-[#A07656] transition-colors" data-id="element-3">
              <X className="w-8 h-8" data-id="element-4" />
            </button>
            <nav className="text-center space-y-8" data-id="element-5">
              {['Home', 'Portfolio', 'Process', 'About', 'Journal', 'Contact'].map((item, index) => <motion.a key={item} href="#" initial={{
            opacity: 0,
            y: 20
          }} animate={{
            opacity: 1,
            y: 0
          }} transition={{
            delay: index * 0.1
          }} className="block text-4xl md:text-5xl font-serif font-semibold text-[#F5F3F0] hover:text-[#A07656] transition-colors" onClick={() => setIsMenuOpen(false)} data-id="element-6">
                  {item}
                </motion.a>)}
            </nav>
          </motion.div>}
      </AnimatePresence>

      {/* Header */}
      <header className="fixed top-0 left-0 right-0 z-40 px-6 py-5 flex justify-between items-center" data-id="element-7">
        <img src="https://cdn.magicpatterns.com/uploads/rsVSuidRepyz9oxNYVg3rK/Iron_Ridge_Logo.png" alt="Iron Ridge Custom Homes" className="h-14 md:h-16 w-auto drop-shadow-[0_2px_12px_rgba(0,0,0,0.5)]" data-id="element-8" />
        <button onClick={() => setIsMenuOpen(true)} className="flex items-center gap-3 group" data-id="element-9">
          <span className="text-sm uppercase tracking-widest font-medium hidden md:block text-white drop-shadow-[0_1px_4px_rgba(0,0,0,0.6)] group-hover:text-[#A07656] transition-colors" data-id="element-10">
            Menu
          </span>
          <Menu className="w-6 h-6 text-white drop-shadow-[0_1px_4px_rgba(0,0,0,0.6)] group-hover:text-[#A07656] transition-colors" data-id="element-11" />
        </button>
      </header>

      <main data-id="element-12">
        <Hero data-id="element-13" />
        <StatsRow data-id="element-14" />
        <ProcessTimeline data-id="element-15" />
        <PortfolioGrid data-id="element-16" />
        <LifestyleSlider data-id="element-17" />
        <LocalExpertise data-id="element-18" />
        <Partners data-id="element-19" />
        <Configurator data-id="element-20" />
        <FieldNotes data-id="element-21" />
        <FooterCTA data-id="element-22" />
      </main>

      <Footer data-id="element-23" />
    </div>;
}